import { Navigate, Outlet, Link as RouterLink } from "react-router";

import type { LinkProps, RedirectProps } from "./types";

/** Renders the matched child route — web wraps React Router's `<Outlet>`. */
export function RouteOutlet(): React.JSX.Element {
  return <Outlet />;
}

/** Declarative redirect — web wraps React Router's `<Navigate>`. */
export function Redirect({ to, replace = true }: RedirectProps): React.JSX.Element {
  return <Navigate to={to} replace={replace} />;
}

/**
 * Cross-platform link — web wraps React Router's `<Link>`. Props it isn't
 * typed for, such as those an `asChild` row adds through `cloneElement`, reach
 * the anchor, and so does the ref (a prop in React 19). Native passes on only
 * `to`, `replace`, `className` and `children`.
 */
export function Link({ to, replace, className, children, ...rest }: LinkProps): React.JSX.Element {
  return (
    <RouterLink {...rest} to={to} replace={replace} className={className}>
      {children}
    </RouterLink>
  );
}
